<template>
  <div>
    <layout-one>
      <div>
        <div><span>课程名称：</span>{{ nowCourseName }}</div>
      </div>
      <div>
        <div><span>通过分数：</span>大于等于{{ corusePassScore }}分</div>
      </div>
      <div>
        <span>单科通过分数线：</span>
      </div>
      <div>
        <div v-for="course in checkedCourseInfo" :key="course.id">
          <span class="specialSpan">{{ course.name }}：</span>大于等于
          <el-input 
            v-model.number="course.passScore" 
            placeholder="请输入单科通过分数线" 
            maxlength="3"
          ></el-input> 分
        </div>
      </div>
      <div class="btnClass">
        <el-button round @click="$router.go(-1)">取消</el-button>
        <el-button type="primary" @click="editSubCourse" round>确定</el-button>
      </div>
    </layout-one>
  </div>
</template>
<script>
import {
    editPlanCourseSubFn,
    getPlanCourseSubListFn
} from "@/http/modules/examSet/score";

export default {
  name: "setSubCourse",
  data() {
    return {
      nowCourseName: this.$route.query.courseName,
      corusePassScore: this.$route.query.corusePassScore,
      checkedCourseInfo: [],
    };
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      const { code,data } = await getPlanCourseSubListFn({
        planId : this.$route.query.planId,
        courseId : this.$route.query.courseId
      });
      if(code === 1){
        this.checkedCourseInfo = data.map(course => {
            return {
                id : course.subCourseId,
                name: course.courseSubName,
                passScore: course.passScore != null ? course.passScore : ''
            };
        });
      }
    },
    async editSubCourse() {
      // 验证分数是否正确格式
      const hasEmptyScore = this.checkedCourseInfo.some(course => {
        const score = course.passScore;
        return typeof score !== 'number' || score < 0 || !Number.isInteger(score);
      });
      if (hasEmptyScore) {
        this.$message.error('请填写所有选中课程的通过分数线，且必须为大于等于0的整数');
        return;
      }
      //准备提交的数据
      const courseSubInfo = this.checkedCourseInfo.map(course => `${course.id}#${course.passScore}`).join(',');
      try {
        const res = await editPlanCourseSubFn({
            planId : this.$route.query.planId,
            courseId : this.$route.query.courseId,
            courseSubInfo: courseSubInfo
        });
        if (res.code === 1) {
          this.$message.success('设置成功');
          this.$router.go(-1);
        } else {
          this.$message.error('设置失败');
        }
      } catch (error) {
        this.$message.error('提交失败');
      }
    },
  },
};
</script>
<style lang="less" scoped>
div {
  margin-bottom: 20px;
  span {
    width: 155px;
    display: inline-block;
    text-align: right;
    font-weight: bold;
    color:#707175;
  }
  .specialSpan{
    width: 200px;
    display: inline-block;
    text-align: right;
    font-weight: normal;
  }
  i {
    margin-left: 5px;
  }
  .courseName {
    width: 200px;
    text-align: left;
  }
}
.btnClass {
    margin-left: 200px;
}
</style>